<div
  class="chart-tooltip"
  [style.left.px]="position?.left"
  [style.top.px]="position?.top"
  [style.opacity]="visible ? 1 : 0"
>
  <div *ngIf="title">
    <div style="display:flex; justify-content: space-between;">
      <div style="margin-right: 10px"><strong>{{ title[0].split(' ')[0] }}</strong></div>
      <div>{{ title[0].split(' ')[1] }}</div>
    </div>
  </div>

  <div *ngIf="legends.length">
    <div style="margin-top:10px"><strong>{{ 'HEADBAND.MODELE.MODAL.GRAPH.LEGENDE_DROP' | translate }}:</strong></div>
    <div *ngFor="let item of legends" style="display:flex; justify-content: space-between;">
      <div style="margin-right: 10px">
        <span [style.color]="item.color">⬤</span> {{ item.label }}
      </div>
      <div>{{ item.value.toFixed(2) }}</div>
    </div>
  </div>

  <div *ngIf="predictions.length">
    <div style="margin-top:10px"><strong>{{ 'HEADBAND.MODELE.MODAL.GRAPH.FORECAST_DROP' | translate }}:</strong></div>
    <div *ngFor="let item of predictions" style="display:flex; justify-content: space-between;">
      <div style="margin-right: 10px">
        <span [style.color]="item.color">⬤</span> {{ item.label }}
      </div>
      <div>{{ item.value.toFixed(2) }}</div>
    </div>
  </div>

  <div *ngIf="ips.length">
    <div style="margin-top:10px"><strong>IPS:</strong></div>
    <div *ngFor="let item of ips" style="display:flex; justify-content: space-between;">
      <div style="margin-right: 10px">
        <span [style.color]="item.color">⬤</span> {{ item.label }}
      </div>
      <div>{{ item.value.toFixed(2) }}</div>
    </div>
  </div>
</div>
